import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { filter, map, take } from "rxjs/operators";

import { GetProductForReviewsDocument, GetProductForReviewsQuery } from "../../common/gql/graphql";
import { DataService } from "../../../core/providers/data/data.service";

import { notNullOrUndefined } from "../../../common/utils/not-null-or-undefined";

export const productReviewsResolver: ResolveFn<GetProductForReviewsQuery['product']> = (route) => {
    return inject(DataService)
        .query(
            GetProductForReviewsDocument,
            {
                slug: route.paramMap.get('slug') || '',
            },
            { ssr: true },
        )
        .pipe(
            map((data) => data.product),
            take(1),
            filter(notNullOrUndefined),
        );
};
